// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import StatsPage from "./StatsPage";
import Demo3DPage from "./Demo3DPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/demo" element={<Demo3DPage />} />
      </Routes>
    </Router>
  );
}

export default App;
